import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';
import { 
  CustomParticipant 
} from "@dndModels";
import { CR_OPTIONS } from "@dndModels/Constants";

import StringBox from "@components/input/strings/StringBox";
import ButtonBox from "@components/input/buttons/ButtonBox";
import SelectStringBox from "@components/input/selects/SelectStringBox";

// import API from '../../../utilities/smart_api';
// import { APIClass } from '../../../utilities/smart_api_class';

interface Props {
  onAdd: (obj: CustomParticipant, count: number) => void;
  disabled?: boolean;
}

export default function CustomParticipantInput({ 
  onAdd, 
  disabled = false }: Props) {
  // const [loading, setLoading] = useState(false);
  // const [fetched, setFetched] = useState(false);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [count, setCount] = useState(1);
  const [max_hit_points, setMaxHitPoints] = useState(0);
  const [armor_class, setArmorClass] = useState(0);
  const [challenge_rating, setCR] = useState(0);
  const [initiative_modifier, setInitiativeModifier] = useState(0);

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 9
        }}>
        <StringBox
          name="Name"
          value={name}
          disabled={disabled}
          onBlur={(changed: string) => {
            setName(changed);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 3
        }}>
        <StringBox
          name="How Many"
          value={`${count}`}
          type="number"
          disabled={disabled}
          onBlur={(changed: string) => {
            setCount(+changed);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <StringBox
          name="Description"
          value={description}
          disabled={disabled}
          multiline
          onBlur={(changed: string) => {
            setDescription(changed);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 3
        }}>
        <StringBox
          name="Max Hit Points"
          value={`${max_hit_points}`}
          type="number"
          disabled={disabled}
          onBlur={(changed: string) => {
            setMaxHitPoints(+changed);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 3
        }}>
        <StringBox
          name="Armor Class"
          value={`${armor_class}`}
          type="number"
          disabled={disabled}
          onBlur={(changed: string) => {
            setArmorClass(+changed);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 3
        }}>
        <SelectStringBox
          name="Challenge Rating"
          value={`${challenge_rating}`}
          options={CR_OPTIONS}
          disabled={disabled}
          onChange={(changed: string) => {
            setCR(+changed);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 3
        }}>
        <StringBox
          name="Initiative Modifier"
          value={`${initiative_modifier}`}
          type="number"
          disabled={disabled}
          onBlur={(changed: string) => {
            setInitiativeModifier(+changed);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <ButtonBox
          name="Add"
          disabled={disabled}
          onClick={() => {
            const obj = new CustomParticipant();
            obj.name = name;
            obj.description = description;
            obj.armor_class = armor_class;
            obj.hp.max = max_hit_points;
            obj.hp.current = max_hit_points;
            obj.challenge_rating = challenge_rating;
            obj.initiative_modifier = initiative_modifier;
            onAdd(obj, count);
            setName("");
            setDescription("");
            setCount(1);
            setArmorClass(0);
            setMaxHitPoints(0);
            setInitiativeModifier(0);
          }}
        />
      </Grid>
    </Grid>
  );
}
